/* eslint-disable no-mixed-operators */

import axios from 'axios/dist/axios';
import { dispatchNetworkEvent } from './event-bus';
import { isOffline } from './offline';

const epicAxios = axios.create();

epicAxios.interceptors.response.use(response => response, error => {
	const offline
			= isOffline()
			|| error.code === 'ERR_NETWORK'
			|| error.message === 'Network Error'
			|| error.request.status === 0;

	const eventName = offline ? 'epic:network:offline' : 'epic:network:error';

	dispatchNetworkEvent(eventName, { error });

	return Promise.reject(error);
});

export default epicAxios;
